import { D2LFetch } from './d2lfetch.js';
export const d2lfetch = new D2LFetch();
